import React from 'react'
import { SlideOutNavItem } from './SlideOutNavItem'
import { featureFlagService } from 'utils/featureFlagService'

export const WorkspaceSlideOutContent: React.FC = () => {
  const { enableDocumentLibrary, enableReminders } = featureFlagService()

  const items = []
  if (enableDocumentLibrary) {
    items.push({ label: 'Documents', path: '/documents' })
  }

  items.push(
    { label: 'Contacts', path: '/contacts' },
    { label: 'Activity', path: '/activity' },
    {
      label: 'Products',
      path: '/products',
    }
  )

  if (enableReminders) {
    items.push({
      label: 'Reminders',

      path: '/reminders',
    })
  }

  return (
    <ul className="list-none m-0 p-0 flex flex-col gap-1.5">
      {items.map((item) => (
        <SlideOutNavItem
          key={item.path}
          label={item.label}
          path={item.path}
          section="workspace"
          keepOpen
        />
      ))}
    </ul>
  )
}
